import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId } from "../../constants.js";
import { usePseudoClasses } from "../../hooks/usePseudoClasses.js";
import { mergeRefs } from "../../utils/refs.js";
import { H as HelpTrigger } from "../../HelpTrigger.js";
import styles from "./styles.module.scss";
const HelpQuestion = React__default.forwardRef(
  ({ children, selected = false, className, onClick, testId }, ref) => {
    const { isHovered, refObject } = usePseudoClasses();
    const classes = classNames(styles.helpquestion, selected && styles["helpquestion--selected"], className);
    return /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        "data-testid": testId,
        className: classes,
        onClick,
        ref: mergeRefs([ref, refObject]),
        "aria-expanded": selected,
        "data-analyticsid": AnalyticsId.HelpQuestion,
        children: [
          /* @__PURE__ */ jsx(HelpTrigger, { htmlMarkup: "span", selected, isHovered }),
          children
        ]
      }
    );
  }
);
HelpQuestion.displayName = "HelpQuestion";
export {
  HelpQuestion as default
};
//# sourceMappingURL=index.js.map
